import React from 'react';
import { FormattedText, formatText } from 'core/i18n';
import { PUBLICA_URL } from 'constants/index';
import MessagesScreen from 'components/messagesScreen/messagesScreen';

const BlockedView = () => {
    const messagesScreenAction = () => {
        window.location.href = PUBLICA_URL;
    };
    return (
        <div className="main-container messages-main-container basic-layering">
            <MessagesScreen
                iconClass="icons icons--icon-warning"
                title={formatText('messagesScreen-identityVerificationAbortedTitle')}
                subtitle={formatText('messagesScreen-identityVerificationAbortedSubTitle')}
                buttonText={formatText('button-understood')}
                buttonClass="form__button form__button-secondary"
                action={messagesScreenAction}
            >
                <FormattedText value="messagesScreen-identityVerificationBlockedContent" />
            </MessagesScreen>
        </div>
    );
};

export default BlockedView;
